class MCartRemoveButton extends HTMLElement {
  constructor () {
    super(),
      this.addEventListener('click', t => {
        t.preventDefault()
        ;(
          this.closest('m-cart') || this.closest('m-cart-drawer-items')
        ).updateQuantity(this.dataset.index, 0)
        //this.closest('m-cart-drawer-items').onCartUpdate();
      })
  }
}
customElements.define('m-cart-remove-button', MCartRemoveButton)
class MCartTemplate extends HTMLElement {
  constructor () {
    super(),
      (this.timerKey = 'm_cart_timer_expiry'),
      (this.timerDuration = 10 * 60 * 1000), // 10 minutes
      (this.timerContainer = document.getElementById('m-cart-timer')),
      (this.timerDisplay = document.getElementById('m-cart-timer-countdown')),
      (this.cartUpdateUnsubscriber = void 0),
      (this.isCartPage = 'cart' === MinimogSettings.templateName),
      (this.cartDrawerWrapper = document.querySelector('m-cart-drawer')),
      (this.cartDrawerInner = document.querySelector('.m-cart-drawer__inner')),
      (this.mainCartItems = this.querySelector('[data-minimog-cart-items]')),
      (this.cartSubTotal = this.querySelector('[data-cart-subtotal]')),
      (this.cartDiscount = this.querySelector('[data-minimog-cart-discounts]')),
      (this.giftWrapping = this.querySelector('[data-minimog-gift-wrapping]'))
    let t = this.cartDrawerInner
    this.isCartPage && (t = document.body),
      (this.loading = new MinimogLibs.AnimateLoading(t, { overlay: t })),
      (this.rootUrl = window.Shopify.routes.root)
    const e = debounce(t => {
      'id' !== t.target.name && this.onChange(t)
    }, 300)
    this.isCartPage
      ? this.mainCartItems.addEventListener('change', e.bind(this))
      : this.addEventListener('change', e.bind(this)),
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, t => {
        this.getCart().then(t => {
          this.updateCartCount(t.item_count)
          if (t.item_count > 0 && !localStorage.getItem(this.timerKey)) {
            this.startCartTimer();
          } else if (t.item_count === 0) {
            this.clearCartTimer();
            this.updateProgressBar(t);
          }
        })
      })
  }
  startCartTimer() {
  let expiry;
  if(document.querySelector('.cart-minutes-wrapper').getAttribute('data-minutes') == '15') {
    let newTimeDuration = 15 * 60 * 1000;
    expiry = Date.now() + newTimeDuration;
  }
  else {
    expiry = Date.now() + this.timerDuration;
  }
  localStorage.setItem(this.timerKey, expiry);
  this.updateCartTimer();
}

clearCartTimer() {
  localStorage.removeItem(this.timerKey);
  if (this.timerContainer) this.timerContainer.classList.add('hidden');
}

updateCartTimer() {
  const expiry = localStorage.getItem(this.timerKey);
  if (!expiry || !this.timerDisplay) return;

  const remaining = expiry - Date.now();
  if (remaining <= 0) {
    this.clearCartTimer();
    return;
  }

  const minutes = Math.floor(remaining / 1000 / 60);
  const seconds = Math.floor((remaining / 1000) % 60)
    .toString()
    .padStart(2, '0');

  this.timerDisplay.textContent = `${minutes}:${seconds}`;
  this.timerContainer.classList.remove('hidden');

  setTimeout(() => this.updateCartTimer(), 1000);
}
  updateCartCount (t) {
    document.querySelectorAll('.m-cart-count-bubble').forEach(e => {
      t > 0
        ? ((e.textContent = t), e.classList.remove('hidden'))
        : e.classList.add('hidden')
    })
    t > 0 ? document.querySelector('#MembershipTable').classList.remove('hidden') : document.querySelector('#MembershipTable').classList.add('hidden');
    if(document.querySelector('.m-cart-drawer__items .m-cart-drawer-item[data-foxkit-product-id="15710953996613"]')) {
      document.querySelector('#MembershipTable').classList.add('hidden')
    } else {
      if(t > 0) {
        document.querySelector('#MembershipTable').classList.remove('hidden');
      }
    }
  }
  getCart () {
    return fetchJSON(this.rootUrl + 'cart.json')
  }
  connectedCallback () {
    this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.cartUpdate,
      t => {
        'main-cart-items' !== t.source && this.onCartUpdate()
      }
    )
      this.updateCartTimer();

    this.getRecommendations();
  }
  disconnectedCallback () {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber()
  }
  onCartUpdate (t = !0) {
    const { routes: e } = window.MinimogSettings
    fetch(`${e.cart}?section_id=cart-template`)
      .then(t => t.text())
      .then(e => {
        const i = new DOMParser().parseFromString(e, 'text/html'),
          n = i.querySelector('[data-minimog-cart-items]'),
          r = i.querySelector('[data-cart-subtotal]'),
          a = i.querySelector('[data-minimog-cart-discounts]'),
          s = i.querySelector('[data-minimog-gift-wrapping]')
  
          // ✅ Update full cart page
          this.mainCartItems.innerHTML = n.innerHTML
          t &&
            ((this.cartSubTotal.innerHTML = r.innerHTML),
            (this.cartDiscount.innerHTML = a.innerHTML),
            (this.giftWrapping.innerHTML = s.innerHTML))
          window.FoxKitV2 &&
            window.FoxKitV2.Modules.InCart &&
            window.FoxKitV2.Modules.InCart.getCart()
       /* if (this.isCartPage) {
        } else {
          document.querySelector('m-cart-drawer').onCartDrawerUpdate();
        }*/
      })
      .catch(t => {})
      this.getRecommendations()
  }
  
  onChange (t) {
    this.updateQuantity(
      t.target.dataset.index,
      t.target.value,
      document.activeElement.getAttribute('name')
    )
  }
  updateQuantity (t, e, i) {
    this.loading.start()
    const { routes: n } = window.MinimogSettings,
      r = JSON.stringify({
        line: t,
        quantity: e,
        sections: this.getSectionsToRender().map(t => t.section),
        sections_url: window.location.pathname
      })
    fetch(`${n.cart_change_url}`, { ...fetchConfig(), body: r })
      .then(t => t.text())
      .then(e => {
        const i = JSON.parse(e)
        let n = document.getElementById(`MinimogDrawer-quantity-${t}`)
        this.isCartPage &&
          (n = MinimogTheme.config.mqlMobile
            ? document.querySelector(
                `.MinimogQuantity-${t}.MinimogQuantity-mobile`
              )
            : document.querySelector(
                `.MinimogQuantity-${t}.MinimogQuantity-desktop`
              ))
        const r = document.querySelectorAll('.m-cart-item')
        if (i.errors)
          return (
            this.loading.finish(),
            (n.value = n.getAttribute('value')),
            void this.updateLiveRegions(t, i.errors)
          )
        this.classList.toggle('m-cart--empty', 0 === i.item_count),
          this.cartDrawerWrapper &&
            this.cartDrawerWrapper.classList.toggle(
              'm-cart--empty',
              0 === i.item_count
            ),
          this.getSectionsToRender().forEach(t => {
            ;(
              document.getElementById(t.id).querySelector(t.selector) ||
              document.getElementById(t.id)
            ).innerHTML = this.getSectionInnerHTML(
              i.sections[t.section],
              t.selector
            )
          })
        const a = i.items[t - 1] ? i.items[t - 1].quantity : void 0
        let s = ''
        r.length === i.items.length &&
          a !== parseInt(n.value) &&
          (s =
            void 0 === a
              ? window.MinimogStrings.cartError
              : window.MinimogStrings.quantityError.replace('[quantity]', a)),
          this.updateLiveRegions(t, s),
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
            ...i,
            source: 'main-cart-items'
          })
      })
      .catch(() => {})
      .finally(() => {
        this.loading.finish()
        this.getRecommendations()
      })
  }
  updateLiveRegions (t, e) {
    let i = document.getElementById(`MinimogCartDrawer-Item-${t}`)
    this.isCartPage && (i = document.getElementById(`MinimogCart-Item-${t}`)),
      '' !== e &&
        i &&
        MinimogTheme.Notification.show({
          target: i,
          type: 'warning',
          message: e
        })
  }
  getSectionInnerHTML (t, e) {
    return new DOMParser().parseFromString(t, 'text/html').querySelector(e)
      .innerHTML
  }

restartAnimation(el, className = 'fade-in') {
  el.classList.remove(className);
  void el.offsetWidth; // forces reflow
  el.classList.add(className);
}
// Add this property to your class or at the top of your file
progressTimeouts = [];
hasCompletedAnimation = false;

updateProgressBar(cart) {
    // Clear all existing timeouts 
    this.progressTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.progressTimeouts = [];

    const wrapper = document.querySelector('.progress-bar-wrapper');
    const bar = document.querySelector('.progress-bar');
    const messageContainer = document.querySelector('.progress-bar__success-message');
    const incentives = document.querySelectorAll('.incentive');

    const subtotal = cart.total_price / 100;
    const hasFreeShipping = subtotal >= 39;
    const hasBOGO = cart.item_count > 1;
    const hasFreeGift = cart.item_count > 1;
    // Progress calculation
    let progress = 0;
    if (hasFreeShipping) progress = 26;
    if (hasBOGO) progress = 60;
    
    // For free gift, animate from 60 to 100
    if (hasFreeGift) {
      // If animation already completed, go straight to 100%
      if (this.hasCompletedAnimation) {
        bar.style.setProperty('--progress-fill', '100%');
      } else {
        // First time: Start at free gift position
        bar.style.setProperty('--progress-fill', '60%');
        
        // After 4 seconds, move to BOGO position (100%)
        const timeout1 = setTimeout(() => {
          bar.style.setProperty('--progress-fill', '100%');
          this.hasCompletedAnimation = true;
        }, 4000);
        this.progressTimeouts.push(timeout1);
      }
    } else {
      // Apply progress immediately for other states
      bar.style.setProperty('--progress-fill', progress + '%');
      // Reset animation flag if user goes back below the threshold
      this.hasCompletedAnimation = false;
    }
    if (cart.item_count > 0) {
      wrapper.classList.remove('hidden');
      // Build progress message
      let message = '';
      let second_message = '';
      const currency = cart.currency || 'USD';
      messageContainer.classList.remove('has-second-message');
      
      if (!hasFreeShipping) {
        const incentive = (39 - subtotal).toLocaleString('en-US', {
          style: 'currency',
          currency
        });
        message = `Spend <strong>${incentive}</strong> more for <strong>Free Shipping!</strong>`;
        this.restartAnimation(messageContainer);
      } else if (hasFreeShipping && !hasBOGO) {
        message = `<strong>✅ Free Shipping Unlocked!</strong>`;
        second_message = `Add a <strong>2nd</strong> item for <strong>50% OFF</strong> + <strong>Free gift</strong> 🎁`;
        this.restartAnimation(messageContainer);
        const timeout2 = setTimeout(() => {
          messageContainer.classList.add('has-second-message');
        }, 4000);
        this.progressTimeouts.push(timeout2);
      } else if (hasBOGO && hasFreeGift) {
        // If animation already completed, show final messages immediately
        if (this.hasCompletedAnimation) {
          message = `<strong>🏅 You've unlocked all rewards</strong>`;
          second_message = `<strong>🏁 Checkout now to claim the offer!</strong>`;
          messageContainer.classList.add('has-second-message');
        } else {
          // First time: First message: Free gift unlocked + BOGO activated
          message = `<strong>✅ Free gift unlocked + BOGO 50% OFF activated</strong>`;
          this.restartAnimation(messageContainer);
          
          // After 4 seconds, change to "You've unlocked all rewards"
          const timeout3 = setTimeout(() => {
            this.restartAnimation(messageContainer);
            messageContainer.querySelector('.first-content').innerHTML = `<strong>🏅 You've unlocked all rewards</strong>`;
          }, 3000);
          this.progressTimeouts.push(timeout3);
          
          // After 9 seconds total, show final checkout message
          const timeout4 = setTimeout(() => {
            messageContainer.querySelector('.second-content').innerHTML = `<strong>🏁 Checkout now to claim the offer!</strong>`;
            messageContainer.classList.add('has-second-message');
          }, 8000);
          this.progressTimeouts.push(timeout4);
        }
      }
  
      messageContainer.querySelector('.first-content').innerHTML = message;
      messageContainer.querySelector('.second-content').innerHTML = second_message;
      // Update incentive badges
      incentives.forEach(item => {
        const unlockType = item.getAttribute('data-unlock');
        let unlocked = false;
  
        if (unlockType === '39' && hasFreeShipping) unlocked = true;
        if (unlockType === '2_items' && hasBOGO) unlocked = true;
        if (unlockType === '3_items' && hasFreeGift) unlocked = true;
  
        item.classList.toggle('unlocked', unlocked);
      });
    } else {
      wrapper.classList.add('hidden');
    }

  }

  getSectionsToRender () {
    return [
      {
        id: 'MinimogCart',
        section: 'cart-template',
        selector: '[data-minimog-cart-items]'
      },
      {
        id: 'MinimogCart',
        section: 'cart-template',
        selector: '[data-cart-subtotal]'
      },
      {
        id: 'MinimogCart',
        section: 'cart-template',
        selector: '[data-minimog-cart-discounts]'
      },
      {
        id: 'MinimogCart',
        section: 'cart-template',
        selector: '[data-minimog-gift-wrapping]'
      }
    ]
  }
  async getRecommendations () {
    const container = document.querySelector('.recommendations-grid')
    container.parentNode.classList.add('is-loading');
    let swiper_recommendations;
    container.removeAttribute('style');
    if(container.parentNode.swiper && container.parentNode.swiper.mounted == true) {
      container.parentNode.swiper.destroy();
    }
    if (!container) return
  
    await fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length > 0) {
          //swiper_recommendations.destroy(true, true);
          let firstProductId = cart.items[0].product_id
          fetch(`/recommendations/products?product_id=${firstProductId}&limit=4&section_id=cart-upsell-items&intent=related`)
            .then(response => response.text())
            .then(data => {
              container.parentNode.parentNode.classList.remove('hidden');
              container.innerHTML = '';
              container.parentNode.style.display = 'block';
              const html = document.createElement('div');
              html.innerHTML = data;
              const recommendations = html;

              if (recommendations && recommendations.innerHTML.trim().length) {
                let recommendation_items = recommendations.querySelectorAll('.recommendation-item');
                recommendation_items.forEach(item => {
                  
                    item.classList.add('swiper-slide');
                  
                  container.appendChild(item);
                });
                //container.innerHTML = recommendations.innerHTML;
                container.parentNode.classList.remove('is-loading');
                
                  container.parentNode.classList.add('swiper-container');
                  container.classList.add('swiper-wrapper');
                  swiper_recommendations = new MinimogLibs.Swiper('.cart-drawer-recommendations .swiper-container', {
                    // Core settings
                    slidesPerView: 1,   // <- exactly one slide per view
                    spaceBetween: 20,   // px between slides
                    loop: true,         // infinite loop
                    navigation: true && {
                      nextEl: container.parentNode.parentNode.parentNode.querySelector('.m-slider-controls__button-next'),
                      prevEl: container.parentNode.parentNode.parentNode.querySelector('.m-slider-controls__button-prev')
                    },
                    pagination:
                    true
                      ? {
                          el: container.parentNode.parentNode.parentNode.querySelector('.swiper-pagination'),
                          clickable: !0,
                          type: 'fraction'
                        }
                      : {
                          el: container.parentNode.parentNode.parentNode.querySelector('.swiper-pagination'),
                          clickable: !0,
                          bulletClass: 'm-dot',
                          bulletActiveClass: 'm-dot--active',
                          renderBullet: function (e, t) {
                            return (
                              '<span class="' +
                              t +
                              '"><svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg></span>'
                            )
                          }
                        },
                  });
              }
            });
            this.updateProgressBar(cart);
        } else {
          container.parentNode.parentNode.classList.add('hidden');
          container.parentNode.classList.remove('is-loading');
          swiper_recommendations.destroy(true, true);
          container.removeAttribute('style')
          container.innerHTML = '';
          this.updateProgressBar(cart);
        }
      })
    }
  ajaxAddToCart(variantId, quantity = 1) {
    this.loading.start();
  
    fetch(`${this.rootUrl}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status && data.message) {
          // Shopify returns errors if product can't be added
          MinimogTheme.Notification.show({
            type: 'warning',
            message: data.message
          });
          return;
        }
  
        // Refresh cart after adding
        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
          source: 'ajaxAddToCart'
        });
  
        this.onCartUpdate(); // refresh contents
        document.querySelector('m-cart-drawer').onCartDrawerUpdate();
      })
      .catch(err => {
        console.error("ATC error:", err);
        MinimogTheme.Notification.show({
          type: 'warning',
          message: "Something went wrong. Please try again."
        });
      })
      .finally(() => {
        this.loading.finish();
      });
  }
  
  
}
customElements.define('m-cart', MCartTemplate)
